import { render, staticRenderFns } from "./LegalDocuments.vue?vue&type=template&id=0fe14648&"
import script from "./LegalDocuments.vue?vue&type=script&lang=js&"
export * from "./LegalDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports